module.exports = __webpack_public_path__ + "img/1440.fc73bb7a.jpg";